import React from 'react';
import CTABanner from '../../components/CTABanner';
import ServicesHero from './ServicesHero';
import ServicesGrid from './ServicesGrid';
import ServicesQuote from './ServicesQuote';
import { useSEO } from '../../hooks/useSEO';

const Services: React.FC = () => {
  useSEO({
    title: 'Our Services',
    description: 'Quality healthcare solutions across Africa. We supply diagnostics kits, surgical, dental, and laboratory equipment.',
    canonical: '/services'
  });

  return (
    <main className="pt-20">
      <ServicesHero />
      <ServicesGrid />
      <ServicesQuote />
      <CTABanner />
    </main>
  );
};

export default Services;
